var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"audioclaim"}},[_c('section',[_c('audclbanner')],1),_c('section',{staticClass:"w_10f8"},[_c('audclcont')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }